const Types = {
	QUEUE: 0,
	DONE: 1,
	LEARNING: 2,
	FORGOTTEN: 3,
	DEAD: 4,
};

class Song {
	constructor(name) {
		this.name = name;
		this.type = Types.QUEUE;
		this.tempo = 100;
		this.links = [];
		this.tags = [];
	}

	convert() {
		if (!this.type)
			this.type = Types.QUEUE;
		if (!this.links)
			this.links = [];
		if (!this.tags)
			this.tags = [];
		if (!this.key || !this.key.trim()) {
			delete this.key;
		}
	}

	dayDelay(now) {
		return ((now || Date.now()) - this.last) / 86400000;
	}

	getScore(now) {
		if (!this.last)
			return 1e9;
		let score = (this.dayDelay(now) + 1) * (6 - (this.stars ?? 0));
		return score * score;
	}

	rate(stars) {
		this.stars = stars;
		this.last = Date.now();
		if (this.type == Types.QUEUE || this.type == Types.FORGOTTEN)
			this.type = Types.LEARNING;
	}

	toQueue() {
		this.type = Types.QUEUE;
	}

	toDone() {
		this.stars = 1;
		this.last = Date.now();
		this.type = Types.DONE;
	}

	toForgotten() {
		this.stars = 0;
		this.type = Types.FORGOTTEN;
	}

	addLink(link) {
		this.links = [...this.links, link];
		return this;
	}

	match(filter) {
		if (filter == "empty" && !this.genre)
			return true;
		if (this.name.toLowerCase().includes(filter))
			return true;
		if (this.genre && this.genre.toLowerCase().includes(filter))
			return true;
		if (this.artist && this.artist.toLowerCase().includes(filter))
			return true;
		for (let t of this.tags) {
			if (t.includes(filter))
				return true;
		}
		return false;
	}
}

export { Song, Types }
